import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";


export default class DeleteMessage extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "deleteMessage";
    }

    public receive(payload: CometOperatorApplication.DeleteMessageCometMessageOpenApiModel): void {
        if (OperatorAccountStore.isCabinetIframe) {
            let messages = ClientUserdataStore.getMessagesByUsername(payload.username);
            if (messages) {
                let message = messages.find(message => message.id == payload.id);
                if (message) {
                    message.isRemoved = true;
                    return;
                }
            }
        }
        ClientUserdataStore.removeMessage({
            messageId: payload.id,
            username: payload.username
        });
    }

}